import getChargeProject from './getChargeProject';
import getExportFileId from './getExportFileId';

export default {
	namespaced: true,
	state: {
		...getChargeProject.state,
		...getExportFileId.state,
	},
	mutations: {
		...getChargeProject.mutations,
		...getExportFileId.mutations,
	},
	actions: {
		...getChargeProject.actions,
		...getExportFileId.actions,
	},
};
